<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap pt-4 mt-4>
        <v-flex xs12>

            <p :class="config.campagnaWeb=='S' ? 'primary--text display-3 font-weight-bold text-md-center sellaBold' : 'primary--text display-3 font-weight-bold text-md-center sellaBold'">Calcola la tua rata</p>
            <v-layout row wrap align-center>
                <v-flex xs12 sm8 mb-5 mt-2>
                    <span :class="config.campagnaWeb=='S' ? 'title' : 'title'">Quale importo vuoi ricevere?</span>
                </v-flex>
                <v-flex xs12 sm8 mt-3>
                    <v-slider
                            v-model="importoErogato"
                            :color="config.campagnaWeb=='S' ? '' : ''"
                            :min="config.importoMinimo"
                            :max="config.importoMassimo"
                            step="250"
                            always-dirty
                            thumb-size="74"
                            thumb-label="always"
                    >
                        <template mt-5 slot="thumb-label" slot-scope="props">
                            <span :class="config.campagnaWeb=='S' ? 'title' : 'title'"> {{props.value}}€</span>
                        </template>
                        <template v-slot:prepend>
                            <v-icon medium :color="config.campagnaWeb=='S' ? 'indigo' : 'indigo'" @click="decrement"> remove </v-icon>
                        </template>

                        <template v-slot:append>
                            <v-icon medium :color="config.campagnaWeb=='S' ? 'indigo' : 'indigo'" @click="increment" > add </v-icon>
                        </template>
                    </v-slider>


                </v-flex>
                <v-flex xs12 sm4 text-xs-center>
                    <v-btn round color="info" class="primary--text" v-on:click="sendRequest">
                        Calcola preventivo
                    </v-btn>
                </v-flex>
            </v-layout>

            <v-layout row wrap align-center>
                <v-flex xs12 sm12>
                    <carousel-3d v-if="ready" :controlsVisible="true" :height="320" :width="240" :display="12" :startIndex="6" >
                        <template v-for="(item,index) in rate">
                            <slide :index="index" :key="index">
                                <SlidePreventivatore :importo="importoErogato" :config="config" :calcRata="rate[index]"/>
                            </slide>
                        </template>
                    </carousel-3d>
                </v-flex>
            </v-layout>

            <v-layout justify-center row wrap>
                <v-dialog v-model="condition" width="500">
                    <template v-slot:activator="{ on }">
                        <v-btn round :color="config.campagnaWeb=='S' ? 'primary' : 'primary'" :class="config.campagnaWeb=='S' ? 'info--text' : 'info--text'" v-on="on">
                            <v-icon dark left>info</v-icon>
                            Termini e condizioni
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="headline grey lighten-2" primary-title>
                            <v-icon left>notes</v-icon>
                            Termini e condizioni
                        </v-card-title>
                        <v-card-text>
                            {{config.terminiCondizioni}}
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn round color="secondary" flat @click="condition = false"> Chiudi</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="limits" width="500">
                    <template v-slot:activator="{ on }">
                        <v-btn round :color="config.campagnaWeb=='S' ? 'primary' : 'primary'" :class="config.campagnaWeb=='S' ? 'info--text' : 'info--text'" v-on="on">
                            <v-icon dark left>info</v-icon>
                            Limiti ed Importi
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="headline grey lighten-2" primary-title>
                            <v-icon left>warning</v-icon>
                            Limiti ed Importi
                        </v-card-title>
                        <v-card-text>
                            {{config.limitiImporti}}
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn round color="secondary" flat @click="limits = false"> Chiudi</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-flex>
    </v-layout>

</template>
<script>
    import {Carousel3d, Slide} from "vue-carousel-3d"
    import SlidePreventivatore from "./SlidePreventivatore"
    import axios from 'axios';

    export default {
        props: {
            config: {}
        },
        components: {
            Carousel3d,
            Slide,
            SlidePreventivatore
        },
        data: function () {
            return {
                rate: [],
                importoErogato: 10000,
                error: null,
                ready: false,
                condition: false,
                limits: false,
            }
        },
        mounted() {
            this.sendRequest();
        },
        methods: {
            sendRequest() {
                let currentObj = this;
                this.ready = false;
                axios.get('vis-prontuario', {
                    params: {
                        importoErogato: this.importoErogato
                    }
                }).then((response) => {
                    currentObj.rate = response.data;
                    currentObj.ready = true;
                }).catch(function (error) {
                    currentObj.error = error;
                });
            },
            increment() {
                this.importoErogato = this.importoErogato + 250
            },
            decrement() {
                this.importoErogato = this.importoErogato - 250
            }
        }
    }
</script>

<style scoped>
    .sellaStencil {
        font-family: 'Sella Stencil' !important;
    }
    .sella {
        font-family: 'Sella';
    }
</style>
